import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setItems(r.data)).catch(()=>{}); }, []);
  return (
    <div className="p-8 md:p-10 max-w-[1600px] mx-auto">
      <div className="overline">Compliance</div>
      <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight mt-2 mb-8">Audit Log</h1>
      <div className="border border-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50">
              <th className="p-4 text-left overline">Timestamp</th>
              <th className="p-4 text-left overline">Actor</th>
              <th className="p-4 text-left overline">Role</th>
              <th className="p-4 text-left overline">Action</th>
              <th className="p-4 text-left overline">Resource</th>
              <th className="p-4 text-left overline">ID</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-slate-500">No log entries.</td></tr>}
            {items.map(l => (
              <tr key={l.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="p-4 font-mono text-xs">{l.timestamp?.slice(0,19).replace("T"," ")}</td>
                <td className="p-4 text-xs">{l.actor_email || "—"}</td>
                <td className="p-4 text-xs uppercase tracking-wider text-slate-500">{l.actor_role}</td>
                <td className="p-4 font-semibold">{l.action}</td>
                <td className="p-4">{l.resource}</td>
                <td className="p-4 font-mono text-xs text-slate-500">{l.resource_id || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
